import { render, staticRenderFns } from "./RewardSpendSection.vue?vue&type=template&id=12f32d1d&scoped=true&"
import script from "./RewardSpendSection.vue?vue&type=script&setup=true&lang=js&"
export * from "./RewardSpendSection.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RewardSpendSection.vue?vue&type=style&index=0&id=12f32d1d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f32d1d",
  null
  
)

export default component.exports